Monitoring.Views ||= {}

class AccountSettings.PrioritizationView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/prioritization"]

  events:
    'click .add-new-prioritization': 'onClickAddNewPrioritization'

  initialize: (@options = {}) ->
    @prioritizations = @options.prioritizations
    @priotizationSelectorView = new AccountSettings.PrioritizationSelectorView({settings: @prioritizations , public_filters: @prioritizations.publicFilters})
    @dragrableListView = new AccountSettings.DragableListView()

  render: =>
    @$el.html(@template())
    @$el.find('.dragable-prioritization-list-container').append(@dragrableListView.render().el)
    @$el.find('.prioritization-dropdown-selector-container').append(@priotizationSelectorView.render().el)
    @$el.find('.prioritization-dropdown-selector-container').hide()

    @bindPrioritizationSelectorAddAndClose()
    @renderAlreadySelectedPrioritizations()
    @bindChosenCombos()

    if @prioritizations.active
      @dragrableListView.enableSortableList()
    else
      @$el.find(".add-new-prioritization").addClass("disabled_link")
      @$el.find(".close_selector_btn").addClass("disabled_link")
      @$el.find(".add_filter_btn").addClass("disabled_link")
      @dragrableListView.disableSortableList()
      @dragrableListView.unbindAllRemoveButton()
    @

  renderAlreadySelectedPrioritizations:=>
    _.each(@prioritizations.teamsAndFiltersPriorization, (prioritization)=>
      filter = {filter_name: prioritization.filterName, filter_id: prioritization.filter_id}
      order_name = I18n.t('monitoring.acd_setting.'+prioritization.order+'.title')
      order = {order_text: order_name, full_order_text: order_name, order_code: prioritization.order}
      @onClickAdd(filter, order)
    )


  bindPrioritizationSelectorAddAndClose: ->
    @priotizationSelectorView .bind('prioritization:selector:click:close', @onClickClose)
    @priotizationSelectorView .bind('prioritization:click:add', @onClickAdd)

  unbindPrioritizationSelectorAddAndClose: ->
    @priotizationSelectorView .unbind('prioritization:selector:click:close')
    @priotizationSelectorView .unbind('prioritization:click:add')

  onClickAddNewPrioritization:->
    if @prioritizations.active
      @$el.find('.add-new-prioritization').hide()
      @$el.find('.prioritization-dropdown-selector-container').show()
      _.defer(@bindChosenCombos)

  onClickAdd:(filter, order) =>
    selectionView = new AccountSettings.FilterAndOrderSelectionView({filter: filter, order: order})
    @dragrableListView.addNewSelection(selectionView)

  onClickClose:=>
    @$el.find('.prioritization-dropdown-selector-container').hide()
    @$el.find('.add-new-prioritization').show()

  disableFilterSelector: ->
    @$el.find('#acd-filter-options-filter').attr("disabled", true);
    @$el.find('#acd-filter-options-order').attr("disabled", true);
    @$el.find('#acd-filter-options-filter').trigger("chosen:updated");
    @$el.find(".add-new-prioritization").addClass("disabled_link")
    @$el.find(".close_selector_btn").addClass("disabled_link")
    @$el.find(".add_filter_btn").addClass("disabled_link")

    @dragrableListView.unbindAllRemoveButton()
    @dragrableListView.disableSortableList()
    @unbindPrioritizationSelectorAddAndClose()

  enableFilterSelector:->
    @$el.find('#acd-filter-options-filter').attr("disabled", false);
    @$el.find('#acd-filter-options-order').attr("disabled", false);
    @$el.find('#acd-filter-options-filter').trigger("chosen:updated");
    @$el.find(".add-new-prioritization").removeClass("disabled_link")
    @$el.find(".add-new-prioritization").removeClass("disabled_link")
    @$el.find(".close_selector_btn").removeClass("disabled_link")
    @$el.find(".add_filter_btn").removeClass("disabled_link")
    @dragrableListView.rebindAllRemoveButton()
    @dragrableListView.enableSortableList()
    @unbindPrioritizationSelectorAddAndClose()
    @bindPrioritizationSelectorAddAndClose()

  prioritizationSettings:=>
    @dragrableListView.toJson()

  bindChosenCombos: =>
    @$el.find('#acd-filter-options-filter').chosen(width: '280px', include_group_label_in_selected: true)
